import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export class TrailerCarousel {
    constructor() {
        this.init();
    }

    init() {
        document.querySelectorAll('.js-trailer-carousel').forEach((el) => {
            this.initCarousel(el);
        });
    }

    initCarousel(root) {
        const thumbContainer = root.querySelector('.js-trailer-carousel-thumbs');
        const mainContainer = root.querySelector('.js-trailer-carousel-main');

        if (!mainContainer) return;

        const counterCurrent = root.querySelector('.js-trailer-carousel-current');
        const counterTotal = root.querySelector('.js-trailer-carousel-total');

        const thumbnails = thumbContainer?.querySelectorAll('.trailer-detail__carousel-thumb') ?? [];

        const mainSwiper = new Swiper(mainContainer, {
            modules: [Navigation, Pagination],
            loop: false,
            speed: 500,
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: root.querySelector('.js-trailer-carousel-next'),
                prevEl: root.querySelector('.js-trailer-carousel-prev'),
            },
            pagination: {
                el: root.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
            },
            on: {
                init: (swiper) => {
                    if (counterTotal) {
                        counterTotal.textContent = String(swiper.slides.length);
                    }
                    updateCounter(swiper);
                },
                slideChange: (swiper) => {
                    updateCounter(swiper);
                },
            },
        });

        function updateCounter(swiper) {
            if (counterCurrent) {
                counterCurrent.textContent = String((swiper.activeIndex ?? 0) + 1);
            }
            thumbnails.forEach((thumbnail, index) => {
                thumbnail.setAttribute('aria-pressed', String(index === swiper.activeIndex));
            });
        }

        // Thumbnail click sync
        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                mainSwiper.slideTo(index);
            });
        });
    }
}
